import { request } from '../../Common/api/client';

export const pgMonitorRequest = (path, method = 'GET', data, params, signal) => request({ url: `/api/admin/pg-settlement-monitor${path}`, method, data, params, signal, timeout: 15000 });
export function monitorItems(data) {
  if (!Array.isArray(data?.items)) throw new Error('검사 이력 응답 형식이 올바르지 않습니다.');
  return { items: data.items, nextCursor: data.nextCursor ?? null };
}
export function refreshOutcome(data) {
  if (data?.enabled === false || data?.skipped === 'DISABLED') return { disabled: true, message: '기능이 비활성화되었습니다.' };
  if (data?.skipped === 'BUSY') return { evaluate: false, message: '다른 잔액 조회가 진행 중입니다. 기존 관측 결과를 표시합니다.' };
  if (data?.skipped === 'INTERVAL') return { evaluate: true, message: '조회 간격 제한으로 PG를 호출하지 않았습니다. 기존 잔액의 재평가 결과를 확인해 주세요.' };
  if (data?.status === 'GOOD') return { evaluate: true, message: '잔액 조회 응답을 받았습니다. 관측 시각과 검사 결과를 확인해 주세요.' };
  if (data?.status === 'ERROR') return { evaluate: true, message: 'PG 잔액 조회에 실패했습니다. 기존 금액을 정상으로 판단하지 마세요.' };
  throw new Error('잔액 조회 결과를 확인할 수 없습니다. 자동으로 재요청하지 않습니다.');
}
export function canChangeIncident(role, incident, action) {
  if (!Number.isInteger(incident?.version)) return false;
  return action === 'acknowledge'
    ? ['SUPER', 'ADMIN'].includes(role) && incident.status === 'OPEN'
    : role === 'SUPER' && ['OPEN', 'ACKNOWLEDGED'].includes(incident.status);
}
